<template>
  <div class="m-modal">
    <div class="m-modal__inner">
      <h1 class="m-modal__inner__title">
        <slot name="title">タイトル</slot>
      </h1>
      <div class="m-modal__inner__content">
        <slot name="body">コンテンツ</slot>
      </div>
      <div class="m-modal__inner__bottom">
        <slot name="footer">下部</slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.m-modal {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.7);
  top: 0;
  left: 0;
  z-index: 1003;
  &__inner {
    display: flex;
    flex-direction: column;
    min-width: 500px;
    max-height: 100%;
    overflow: scroll;
    background-color: #fff;
    box-shadow: 0 0 10px #ccc;
    &__title {
      margin: 0.5rem;
      padding: 0.5rem;
      background: #37474F;
      color: #fff;
    }
    &__content {
      padding: 0 .5rem 0 .5rem;
      flex: 1;
    }
    &__bottom {
      padding: .5rem;
      align-self: flex-end;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Modal.vue?27428bb2